import {Routes} from '@angular/router';
import {ConsultationComponent} from './routes/consultation/consultation.component';
import {HomeComponent} from './routes/home/home.component';
import {StoreComponent} from './routes/store/store.component';

export const routes: Routes = [
    {
        path: '',
        component: HomeComponent
    },
    {
        path: 'store',
        component: StoreComponent
    },
    {
        path: 'consultation',
        component: ConsultationComponent
    }
];
